<template>
  <div class="flex h-full flex-col">
    <div class="h-full">
      <slot />
    </div>
    <div class="flex items-center justify-end">
      <a class="mr-4 cursor-pointer text-zt-dark-300 hover:underline">{{
        buttonNames[1]
      }}</a>
      <zt-button @click="$emit('activeButton')">{{ buttonNames[0] }}</zt-button>
    </div>
  </div>
</template>

<script>
import ztButton from '../ztButton/ztButton.vue'

export default {
  name: 'ztDropdownSubItem',
  inheritAttrs: false,
  components: {
    ztButton,
  },
  props: {
    buttonNames: {
      type: Array,
      default: () => ['Aceptar', 'Cancelar'],
    },
  },
}
</script>


